import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { resetField, getRecipeIngredients } from "../../../../store/actions";

class RecipeIngredients extends Component {
	componentDidMount() {
		const { recipeId, getRecipeIngredients, scale = 1 } = this.props;
		if (recipeId) {
			getRecipeIngredients(recipeId, scale);
		}
	}

	componentDidUpdate(prevProps) {
		const { recipeId, getRecipeIngredients, scale = 1 } = this.props;
		if ((recipeId && prevProps.recipeId !== recipeId) || prevProps.scale !== scale) {
			getRecipeIngredients(recipeId, scale);
		}
	}

	componentWillUnmount() {
		this.props.resetField("Recipes.recipeNutritionFacts", []);
	}

	renderItem = (list, showPercentage = true, isHeading = false) => {
		return (
			<React.Fragment>
				{list.map((item) => {
					const weigh = item.val && Math.ceil(item.val);
					const weighWithUnit = weigh > 999 ? Math.ceil(weigh / 1000) + "g" : weigh + "mg";
					const percentage = Math.ceil(item.dri_2000) + "%";
					return (
						<div
							className={`d-flex align-items-center pt-2 pb-2 ${isHeading ? "border-bottom-default" : ""}`}
							key={item.id}>
							<span className={`flex-fill mr-2 ${isHeading ? "bold" : ""}`}>
								{item.name} {item.val && weighWithUnit}
							</span>
							{showPercentage ? (
								<span className="bold text-primary-dark">{percentage}</span>
							) : (
								<span className="bold text-primary-dark text-right">{item.cal_fat}</span>
							)}
							{item.value && <div>{item.value}</div>}
						</div>
					);
				})}
			</React.Fragment>
		);
	};

	render() {
		const { recipeIngredients } = this.props;
		return recipeIngredients && recipeIngredients.length ? (
			<ul className="check-list">
				{recipeIngredients.map(({ ingredient__id, main, text }) => (
					<li key={ingredient__id} className={`${main ? "bold" : ""}`} dangerouslySetInnerHTML={{ __html: text }} />
				))}
			</ul>
		) : null;
	}
}

const mapStateToProps = (state) => {
	return {
		recipeIngredients: get(state, "Recipes.recipeIngredients", [])
	};
};

const mapDispatchToProps = { resetField, getRecipeIngredients };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecipeIngredients);
